import React, { useState } from 'react'
import { CAlert, CButton, CCol, CForm, CFormInput, CFormLabel, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow } from '@coreui/react'
import { request } from '../../services'

function PlanModal({ open, onClose, onCreated }) {
  const [form, setForm] = useState({ price: '0.00', users: '1', custom_scripts: '0' })
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  async function submit(event) {
    event.preventDefault()
    setSaving(true)
    setError('')
    const res = await request('create_payment_plan', { method: 'POST', body: form })
    setSaving(false)
    if (!res.ok) {
      setError(res.data?.error || Object.values(res.data?.errors || {})[0] || 'No se pudo crear el plan')
      return
    }
    onCreated(res.data.uuid)
  }

  return (
    <CModal visible={open} onClose={onClose}>
      <CForm onSubmit={submit}>
        <CModalHeader><CModalTitle>Crear plan de agencia</CModalTitle></CModalHeader>
        <CModalBody>
          {error ? <CAlert color="danger">{error}</CAlert> : null}
          <CRow>
            <CCol md={4}><CFormLabel>Precio</CFormLabel><CFormInput value={form.price} onChange={(event) => setForm({ ...form, price: event.target.value })} /></CCol>
            <CCol md={4}><CFormLabel>Usuarios</CFormLabel><CFormInput value={form.users} onChange={(event) => setForm({ ...form, users: event.target.value.replace(/\D/g, '') })} /></CCol>
            <CCol md={4}><CFormLabel>Custom scripts</CFormLabel><CFormInput value={form.custom_scripts} onChange={(event) => setForm({ ...form, custom_scripts: event.target.value.replace(/\D/g, '') })} /></CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton color="light" onClick={onClose}>Cancelar</CButton>
          <CButton color="success" className="btn-brand" type="submit" disabled={saving}>Siguiente</CButton>
        </CModalFooter>
      </CForm>
    </CModal>
  )
}

export default PlanModal
